import $ from 'jquery';
import LinkedOptions from './LinkedOptions';
import ThemeUtils from './ThemeUtils';

// This does not meet our current code standards, but should be replaced
// with the shopify-variants library
export default class VariantHelper {
  constructor(options) {
    const defaultOptions = {
      $addToCartButton: null, // Set with object of add to cart button
      $priceFields: null, // Set with object containing price(s)
      $productForm: null, // Set with object containing the `data-product-form` attribute
      $productThumbnails: null, // Set with object containing thumbnails
      $selector: null, // Set with an object that contains select/input[type=checkbox] objects
      type: 'select', // Or radio
      productJSON: null, // Set with product JSON information
      productSettings: null, // Set with JSON containing product message strings and/or display options
    };

    this.options = ThemeUtils.extend(defaultOptions, options);

    this.$body = $(document.body);
    this.linkedOptions = null;
    this.enableHistory = false;
    this.$masterSelect = this.options.$productForm.find('.product-select');

    this.isThemeEditor = window.Shopify && window.Shopify.designMode;

    this.enableHistory = !this.isThemeEditor && history.replaceState && this.options.productSettings.enableHistory;

    this._init();
    this._bindEvents();
  }

  _init() {
    if (this.options.type === 'select') {
      $.each(this.options.$selector, (index, select) => this._setSelectLabel(null, $(select)));
    }

    if (this.options.productSettings.linkedOptions) {
      this.linkedOptions = new LinkedOptions(this.options);
    }
    this._updateVariant();
  }

  _bindEvents() {
    this.options.$selector.on('change', event => this._updateVariant(event));
  }

  _setSelectLabel(event = null, $target) {
    if ($target == null) { $target = false; }
    if (!$target) {
      $target = $(event.currentTarget);
    }

    const selectedOption = $target.find('option:selected').val();

    $target
      .prev('[data-select-text]')
      .text(selectedOption);
  }

  _getCurrentOptions() {
    const productOptions = [];
    let $inputs = this.options.$selector;

    if (this.options.type === 'radio') {
      $inputs = $inputs.filter(':checked');
    }

    $inputs.each((index, element) => productOptions.push($(element).val()));

    return productOptions;
  }

  _getVariantFromOptions(productOptions) {
    if (this.options.productJSON.variants == null) { return; }

    let foundVariant = null;

    this.options.productJSON.variants.forEach((variant) => {
      const isMatch = productOptions.every((value, index) => variant.options[index] === value);

      if (isMatch) {
        foundVariant = variant;
      }
    });

    return foundVariant;
  }

  _updateMasterSelect(variant) {
    if (!variant) { return; }

    this.$masterSelect.find(`[data-variant-id=${variant.id}]`).prop('selected', true);

    this.$masterSelect.trigger('change');
  }

  _updatePrice(variant) {
    const { $addToCartButton } = this.options;
    const { $priceFields } = this.options;
    const { productSettings } = this.options;

    if (variant) {
      const variantPrice = Shopify.formatMoney(variant.price, window.Theme.moneyFormat);
      const variantComparePrice = Shopify.formatMoney(variant.compare_at_price, window.Theme.moneyFormat);

      if (variant.available) {
        $addToCartButton
          .val(productSettings.addToCartText)
          .removeClass('disabled')
          .removeAttr('disabled');
      } else {
        $addToCartButton
          .val(productSettings.soldOutText)
          .addClass('disabled')
          .attr('disabled', 'disabled');
      }

      if (variant.compare_at_price > variant.price) {
        $priceFields
          .find('.money:first-child')
          .html(variantPrice);

        $priceFields
          .find('.product-price-compare')
          .html(variantComparePrice)
          .removeClass('hidden');
      } else {
        $priceFields
          .find('.money')
          .html(variantPrice);

        $priceFields
          .find('.product-price-compare')
          .html('')
          .addClass('hidden');
      }
    } else {
      // Variant doesn't exist
      $addToCartButton
        .val(productSettings.unavailableText)
        .addClass('disabled')
        .attr('disabled', 'disabled');
    }
  }

  _updateTaxLine(variant) {
    if (!variant) return;

    this.options.$priceFields.each((i, el) => {
      const taxLine = el.querySelector('[data-tax-line]');

      if (!taxLine) return;

      if (variant.taxable) {
        taxLine.classList.remove('product__tax-label--hidden');
      } else {
        taxLine.classList.add('product__tax-label--hidden');
      }
    });
  }

  _updateUnitPrice(variant) {
    if (!variant) return;

    this.options.$priceFields.each((i, el) => {
      const variantFields = {
        unitPrice: el.querySelector('[data-unit-price]'),
        totalQuantity: el.querySelector('[data-total-quantity]'),
        unitPriceAmount: el.querySelector('[data-unit-price-amount]'),
        unitPriceMeasure: el.querySelector('[data-unit-price-measure]'),
      };

      if (variantFields.unitPrice && variant.unit_price_measurement) {
        variantFields.totalQuantity.innerHTML = `${variant.unit_price_measurement.quantity_value}${variant.unit_price_measurement.quantity_unit}`;

        variantFields.unitPriceAmount.innerHTML = Shopify.formatMoney(variant.unit_price, window.Theme.moneyFormat);
        if (variant.unit_price_measurement.reference_value === 1) {
          variantFields.unitPriceMeasure.innerHTML = variant.unit_price_measurement.reference_unit;
        } else {
          variantFields.unitPriceMeasure.innerHTML = `${variant.unit_price_measurement.reference_value}${variant.unit_price_measurement.reference_unit}`;
        }
        variantFields.unitPrice.classList.remove('product__unit-price--hidden');
      } else if (variantFields.unitPrice) {
        variantFields.unitPrice.classList.add('product__unit-price--hidden');
      }
    });
  }


  _updateImages(variant) {
    if (variant && variant.featured_image && variant.featured_image.id && this.options.$productThumbnails) {
      this.options.$productThumbnails.filter(`[data-image-id='${variant.featured_image.id}']`).trigger('click');
    }
  }

  _updateHistory(variant) {
    if (!this.enableHistory || (variant == null)) { return; }

    const newUrl = [
      window.location.protocol,
      '//',
      window.location.host,
      window.location.pathname,
      '?variant=',
      variant.id,
    ];

    const variantUrl = newUrl.join('');
    window.history.replaceState({ path: variantUrl }, '', variantUrl);
  }

  _updateVariant(event) {
    if (event && (this.options.type === 'select')) {
      this._setSelectLabel(event);
    }

    const productOptions = this._getCurrentOptions();
    const variant = this._getVariantFromOptions(productOptions);

    this._updateMasterSelect(variant);
    this._updatePrice(variant);
    this._updateUnitPrice(variant);
    this._updateTaxLine(variant);
    this._updateImages(variant);
    if (event) {
      this._updateHistory(variant);
    }

    this.options.$productForm.trigger('variant-helper:variant-change', {
      variant,
      product: this.options.productJSON,
    });
  }

  prepareRemove() {
    this.options.$selector.off('change');
    if (this.linkedOptions) {
      this.linkedOptions.prepareRemove();
    }
  }
}
